import { createRef } from 'react';

import SectionContentNavigation from '@spotahome/ui-library/src/tenant/components/SectionContentNavigation';

import './CountryContentNavigation.scss';

const items = [
  {
    section: 'top-cities',
    textKey: 'countries.navigation.top-cities'
  },
  {
    section: 'all-cities',
    textKey: 'countries.navigation.all-cities'
  },
  {
    section: 'articles',
    textKey: 'countries.navigation.articles'
  },
  {
    section: 'testimonials',
    textKey: 'countries.navigation.testimonials'
  },
  {
    section: 'faqs',
    textKey: 'countries.navigation.faqs'
  }
];

const CountryContentNavigation = () => {
  return (
    <SectionContentNavigation
      items={items.map(item => ({
        data: item,
        ref: createRef()
      }))}
      className="country-content-navigation"
      containerClassName="country-content-navigation__container"
      itemClassName="country-content-navigation__navigation-item"
      selectedItemClassName="country-content-navigation__navigation-item--active"
      eventPrefix="countries"
      showArrows={false}
    />
  );
};

export default CountryContentNavigation;
